import {useValidApp} from '$hooks/useValidApp'

import useInsuranceMyAssetQuery from '../useInsuranceMyAssetQuery'

const useMyDataAgreementWebAppEnv = () => {
    const {data} = useInsuranceMyAssetQuery()
    const {isValidApp} = useValidApp()
    return isValidApp && data?.isMydataInsuranceConnected
}

export default useMyDataAgreementWebAppEnv
